import { ApolloQueryResult, useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { notNil } from '@shared/util/notNil';
import { useCurrentBusinessId } from './useCurrentBusinessId';

interface ChannelListHook {
  channels: MBAPI.ChannelListItem[];
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<MBAPI.ChannelListQuery>>;
}

export function useChannelList(): ChannelListHook {
  const businessId = useCurrentBusinessId();
  const { data, loading, refetch } = useQuery<
    MBAPI.ChannelListQuery,
    MBAPI.ChannelListQueryVariables
  >(Queries.channel.list, {
    variables: { businessId: businessId ?? -1 },
    skip: isNil(businessId),
  });

  return useMemo(
    () => ({
      channels: data?.me?.business?.channels?.filter(notNil) ?? [],
      loading,
      refetch,
    }),
    [data, loading, refetch],
  );
}
